export default { sha: '4424e8215bff30c2d50532aa491c5616413b8a92', buildNumber: 'undefined' }
